/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const mTop40Css = css`
  margin-top: 40px;
`;

export const mTop16Css = css`
  margin-top: 16px;
`;
